import defaultOptions from './options/defaults';
import store from './store';
import Uri from '../../common/Uri';

const APPLICATION_IDENTIFIER = {
    PORTAL: 'portal',
    MOJORANGE: 'mojorange'
};

class ApplicationContext {
    getState() {
        return store.getState();
    }

    getStartArguments() {
        const state = store.getState();
        return state.settings.startArguments || new Uri(state.main.location).searchObject;
    }

    isMojOrange() {
        const state = store.getState();
        const args = state.settings.startArguments || new Uri(state.main.location).searchObject;
        const mo = args['mojorange'] || null;
        return mo !== null;
    }

    getApplicationIdentifier() {
        const args = this.getStartArguments();
        for (const key in args) {
            if (Object.prototype.hasOwnProperty.call(args, key)) {
                const apivalue = defaultOptions.chatOptions.registration.api[key] || undefined;
                if (apivalue !== undefined && args[key] === apivalue) {
                    return key;
                }
            }
        }
        return APPLICATION_IDENTIFIER.PORTAL;
    }
}

export default new ApplicationContext();
